import React from "react";
import { motion } from "framer-motion";
import { LANDING } from "@/constants/testIds";

const STATS = [
  { value: "₹2,100Cr+", label: "Processed across categories" },
  { value: "2 Lakh+", label: "Active users on the marketplace" },
  { value: "4.6★", label: "Average Play Store rating" },
  { value: "Verified", label: "KYC-checked sellers only" },
];

export const Stats = () => {
  return (
    <section
      data-testid={LANDING.statsSection}
      className="relative py-20 bg-[#FAFAF7] border-y border-[#E5E5E0]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              className="text-center md:text-left md:border-l md:first:border-l-0 md:border-[#E5E5E0] md:pl-6"
            >
              <p className="font-serif text-4xl sm:text-5xl tracking-tight text-[#0A0A0A] leading-none">
                {s.value}
              </p>
              <p className="mt-3 text-sm text-[#4A4A4A] max-w-[200px] mx-auto md:mx-0">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
